import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

/**
 * In-app 404 page rendered for authenticated users hitting an unknown route.
 *
 * Unlike `NotFoundPage` (which is the public marketing 404 with its own header,
 * footer, and "Sign In" CTA), this component is rendered INSIDE
 * `AuthenticatedLayout`, so it inherits the sidebar nav and the user-avatar
 * topbar. It must therefore avoid duplicating any chrome and must point its
 * primary CTA at `/dashboard` rather than the public landing page.
 *
 * See issue #1765 — authenticated 404s previously rendered the marketing
 * shell, stripping sidebar/avatar and showing a misleading "Sign In" button.
 */
function NotFoundInApp() {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                404 &mdash; Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                The page you are looking for does not exist or has been moved.
            </Typography>
            <Box className="not-found-actions">
                <Button component={Link} to="/dashboard" variant="contained" size="large" className="btn btn-primary btn-large">
                    Back to Dashboard
                </Button>
            </Box>
        </Container>
    );
}

export default NotFoundInApp;
